var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleNotch = function SvgCircleNotch(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7644 5.29626C14.4304 2.67414 9.58233 2.89978 6.50892 5.97319C3.19199 9.29013 3.19199 14.6741 6.50892 17.9911C9.82586 21.308 15.2099 21.308 18.5268 17.9911C21.6211 14.8967 21.8288 10.0034 19.1497 6.66761L17.9387 7.87865C19.9561 10.5405 19.7516 14.3627 17.325 16.7893C14.6751 19.4392 10.3607 19.4392 7.71071 16.7893C5.06077 14.1393 5.06077 9.82492 7.71071 7.17498C10.1161 4.76955 13.893 4.5476 16.5516 6.50913L17.7644 5.29626Z",
    fill: "black",
    fillOpacity: 0.87
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleNotch);
export { ForwardRef as ReactComponent };